
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getJobstatus = async () => {
  return await get<ApiResponse<any[]>>("/jobstatus").then((res)=>{
      return res
    })
};

 